import { Loader2 } from "lucide-react";
import { DollarCircle } from "components/icons/components/DollarCircle";
import { CAMPAIGN_INTERNAL_STATUSES } from "pages/constants";
import { SubmitButton } from "components/SubmitButton";
import { SkipDesignSubmitAndPayButton } from "./SkipDesignSubmitAndPayButton";

interface SubmitAndPayButtonProps {
  internalStatus: keyof typeof CAMPAIGN_INTERNAL_STATUSES;
  loading: boolean;
  disabled: boolean;
  handleClickSubmitAndPay: () => void;
  isPaymentSkipped: boolean;
  isNotDesign: boolean;
  type: "primary" | "secondary";
}

export const SubmitAndPayButton = ({
  internalStatus,
  loading,
  disabled,
  handleClickSubmitAndPay,
  isPaymentSkipped,
  isNotDesign,
  type,
}: SubmitAndPayButtonProps) => {
  if (isNotDesign) {
    return (
      <SkipDesignSubmitAndPayButton
        internalStatus={internalStatus}
        loading={loading}
        disabled={disabled || isNotDesign}
        handleClickSubmitAndPay={handleClickSubmitAndPay}
        isPaymentSkipped={isPaymentSkipped}
        type={type}
      />
    );
  }

  if (internalStatus !== CAMPAIGN_INTERNAL_STATUSES.DRAFT) {
    return null;
  }

  return (
    <SubmitButton
      onClick={handleClickSubmitAndPay}
      disabled={disabled}
      type={type}
      dataCy="submitAndPayButton"
      icon={loading && isPaymentSkipped ? <Loader2 className="h-5 w-5 animate-spin" /> : <DollarCircle />}
    >
      {!isPaymentSkipped ? "Submit and pay" : "Submit"}
    </SubmitButton>
  );
};
